import { map, mapTo, take } from 'rxjs/operators';
import { ConnectionManagerNetworks } from '../../../helpers/constants';
import { setDefaultIntegrations } from '../slice';

export default (action$, state$) =>
  state$.pipe(
    take(1),
    mapTo({
      integrations: Object.values(ConnectionManagerNetworks),
    }),
    map(setDefaultIntegrations)
  );
